import controller from './promocode.controller';

export default {
  bindings: {
    packet: '<',
    discount: '=',
    promocode: '=',
    packages: '<',
    msisdn: '<?',
    offerable: '<'
  },
  controller,
  template: require('./promocode.html')
};



// WEBPACK FOOTER //
// src/app/components/promocode/promocode.component.ts